import angular from 'angular';
import loanVariationModal from './loanVariationModal';
import loanVariationSummary from './loanVariationSummary';

export default angular.module('loanVariations.scenes', [
  loanVariationModal,
  loanVariationSummary,
]).name;
